/* eslint-disable max-len */
import React, { useRef, useEffect } from 'react';

export const InitialMaker = ({collapse, firstName, lastName }) => {
    const handleInitials =()=>{
        const initials = firstName.charAt(0).toUpperCase() + lastName.charAt(0).toUpperCase()
        return initials

    }

    return <div className={`bg-[#c2ddf0] min-w-[52px] min-h-[52px] flex items-center justify-center border-4 ${collapse?'mt-[10px]':''} border-[#1c6eb4] rounded-xl`}>        
        <p className='text-[#1c6eb4] p-1 text-md font-medium'>{handleInitials(firstName, lastName)}</p>

    </div>;
};

